import { Navigate, useLocation } from 'react-router-dom';
import { withPreservedSearchHash } from '@/lib/navigation/with-preserved-search-hash';

interface PreserveLocationNavigateProps {
  pathname: string;
  replace?: boolean;
}

export function PreserveLocationNavigate({
  pathname,
  replace = true,
}: PreserveLocationNavigateProps) {
  const location = useLocation();
  return (
    <Navigate replace={replace} to={withPreservedSearchHash(pathname, location)} />
  );
}
